import React from 'react';
import cls from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { string, bool, node } from 'prop-types';

import Cycle from '../FullLoading/Cycle';

import s from './index.css';

function Button({ children, className, fullWidth, loading, ...rest }) {
  return (
    <button
      className={cls(s.button, className, fullWidth && s.fullWidth)}
      {...rest}
    >
      {loading && (
        <div className={s.loadingIcon}>
          <Cycle />
        </div>
      )}{' '}
      {children}
    </button>
  );
}

Button.propTypes = {
  children: node.isRequired,
  className: string,
  fullWidth: bool,
  loading: bool,
};

Button.defaultProps = {
  className: '',
  fullWidth: false,
  loading: false,
};

export default withStyles(s)(Button);
